var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDropdownArrowDown = function SvgDropdownArrowDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.912 9.304a.644.644 0 0 0-.25-.223.76.76 0 0 0-.344-.081H8.682c-.12 0-.24.028-.344.081a.644.644 0 0 0-.25.222.538.538 0 0 0 .01.602l3.318 4.79a.65.65 0 0 0 .249.211.76.76 0 0 0 .67 0 .65.65 0 0 0 .249-.21l3.318-4.791a.538.538 0 0 0 .01-.601z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropdownArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dropdown-arrow-down.27a0697b5100988d53d48d28806a6c6d.svg";